import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { businessInfo, services } from '../mockData';

const Footer = () => {
  return (
    <footer className="footer-main">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-column">
            <img 
              src="https://customer-assets.emergentagent.com/job_premium-auto-care-24/artifacts/isyscnmq_logo.JPG" 
              alt="Prime Auto Logix" 
              className="footer-logo"
            />
            <p className="footer-tagline">{businessInfo.tagline}</p>
            <p className="footer-description">
              Your trusted automotive service provider in the Waterloo Region. 
              Professional detailing, tinting, and upgrade services.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/booking">Book Now</Link></li>
              <li><Link to="/contact">Request Quote</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h3 className="footer-heading">Our Services</h3>
            <ul className="footer-links">
              {services.map((service) => (
                <li key={service.id}>
                  <Link to={`/services#${service.slug}`}>{service.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h3 className="footer-heading">Contact Us</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Phone size={18} />
                <a href={`tel:${businessInfo.phone}`}>{businessInfo.phoneFormatted}</a>
              </div>
              <div className="footer-contact-item">
                <Mail size={18} />
                <a href={`mailto:${businessInfo.emails.service}`}>
                  {businessInfo.emails.service}
                </a>
              </div>
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>{businessInfo.address.full}</span>
              </div>
              <div className="footer-contact-item">
                <Clock size={18} />
                <div className="hours-info">
                  <span>{businessInfo.hours.weekdays}</span>
                  <span>{businessInfo.hours.saturday}</span>
                  <span>{businessInfo.hours.sunday}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {new Date().getFullYear()} {businessInfo.name}. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <span>Proudly serving the Waterloo Region</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
